import {Component, OnDestroy, OnInit} from '@angular/core';
import {SectionComponent} from '../../../../../../elements/section/section.component';
import {TitleBackgroundComponent} from '../../../../../../elements/title-background/title-background.component';
import {MainBusyBeeComponent} from '../../../../../main/items/main-busy-bee/main-busy-bee.component';
import {
  Card,
  CardsArray,
} from '../../../../../../../model/cards';
import {RunningLineComponent} from '../../../../../../elements/running-line/running-line.component';
import {MainBestHotelsComponent} from '../../../../../main/items/main-best-hotels/main-best-hotels.component';
import {MainDestinationsComponent} from '../../../../../main/items/main-destinations/main-destinations.component';
import {HeaderService} from '../../../../../../../services/header-service';
import {SectionScrollerComponent} from '../../../../../../elements/section-scroller/section-scroller.component';
import {Continent} from '../../../../../../../model/circle';
import {ActivatedRoute, Router} from '@angular/router';
import {getLastSegment} from '../../../../../../../functions/getLastSegment';
import {RouteService} from '../../../../../../../services/route-service';
import {LocationDto, Points} from '../../../../../../../model/continent';
import {FooterService} from '../../../../../../../services/footer-service';
import {environment} from '../../../../../../../environments/environment';
import {NgForOf, NgIf, NgStyle} from '@angular/common';
import {PaginationParams} from '../../../../../../../model/pagination';
import {HotelDtoService} from '../../../../../../../services/hotel-dto-service';
import {LoopedSliderComponent} from '../../../../../../elements/looped-slider/looped-slider.component';
import {NavigationService} from '../../../../../../../services/navigation-service';
import {getCssNumber} from '../../../../../../../functions/getCssNumber';
import {findIconByCss, findTextByCss} from '../../../../../../../functions/findIconByAlt';
import {
  findFirstContinent, findFirstCountry,
} from '../../../../../../../functions/findFirstCityUrl';
import {LoginService} from '../../../../../../../services/login.service';
import {TokenStorageService} from '../../../../../../../services/token.storage.service';
import {AdminPreviewComponent} from '../../../../../../elements/admin-preview/admin-preview.component';
import {Text} from '../../../../../../../model/text';
import {FcLoadingComponent} from '../../../../../../elements/fc-loading/fc-loading.component';
import {Subject, takeUntil} from 'rxjs';
import {findLastNumber} from '../../../../../../../functions/getDays';
import {getFirstSentence} from '../../../../../../../functions/getFirstSentence';
import {MenuService} from '../../../../../../../services/menu-services';
import {LoadingService} from '../../../../../../../services/loading-service';

@Component({
  selector: 'app-route-page',
  imports: [
    SectionComponent,
    TitleBackgroundComponent,
    MainBusyBeeComponent,
    RunningLineComponent,
    MainBestHotelsComponent,
    MainDestinationsComponent,
    SectionScrollerComponent,
    NgForOf,
    LoopedSliderComponent,
    NgIf,
    AdminPreviewComponent,
    NgStyle,
    FcLoadingComponent
  ],
  templateUrl: './route-page.component.html',
  standalone: true,
  styleUrl: './route-page.component.scss'
})
export class RoutePageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    protected interfaceService: HeaderService,
    private route: ActivatedRoute,
    private router: Router,
    protected routeService: RouteService,
    public footerService: FooterService,
    protected hotelService: HotelDtoService,
    public navigationService: NavigationService,
    protected loginService: LoginService,
    protected tokenStorageService: TokenStorageService,
    protected menuService: MenuService,
    public loadingService: LoadingService,) {}

  tab: boolean = false;
  loading: boolean = false;
  loadingCircle: boolean = false;
  adminDisplay: boolean = false;
  uncorrectedUrl: boolean = false;
  displayPageFalse: boolean = false;

  routeDto: LocationDto = new LocationDto();
  sliderCards: Card[] = [];
  points: Points[] = [];
  antPoints: Points[] = [];
  lastPoint: Points | null = null;
  hotelCards: Card[] = [];
  typeContent: string | undefined = undefined;

  hotelHeight: number = 0;

  isMobile: boolean = false;

  grid: number = 4.2;

  hotelPaginationParams: PaginationParams = {
    query: '',
    pageSize: 500,
    pageNumber: 0,
    sort: 'rating:asc',
    countryId: ''
  };

  runningText: Text[] = [];
  loadingSlider: boolean = false;

  ngOnInit() {
    this.menuService.setMobileSpecialStyle(true);
    this.interfaceService.setPageInterface('header-container-white');
    this.interfaceService.setHeaderStyle(true);
    if (window.innerWidth < 769) {
      this.isMobile = true;
      if (window.innerWidth < 456) {
        this.grid = 1.3;
      } else {
        this.grid = 2.1;
      }
    }
    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getData();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.menuService.setMobileSpecialStyle(false);
    this.interfaceService.setHeaderStyle(false);
    this.footerService.setFooterColor('rgba(57, 122, 158, 1)');
    this.footerService.setFooterImage('');
    this.footerService.setFooterStyle('');
  }

  isLoggedIn(): boolean {
    const loginInfo = this.tokenStorageService.getLoginInfo();
    return !!loginInfo && !!loginInfo.token;
  }

  getData() {
    this.loading = true;
    this.loadingSlider = true;
    this.checkLoading();
    this.resetData();
    const x = this.route.snapshot.paramMap.get('countryName') ?? '';
    const z = this.route.snapshot.paramMap.get('name') ?? '';
    const url = getLastSegment(this.router.parseUrl(this.router.url));
    this.routeService.getRouteByUrl(url)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.routeDto = new LocationDto(data);
        let countEn = '';
        let countRu = '';
        this.routeDto.points.forEach((p) => {
          if (p.titleEn !== undefined && p.titleEn.length > 0) {
            countEn = findLastNumber(p.titleEn, 'en');
          }
          if (p.titleRu !== undefined && p.titleRu.length > 0) {
            countRu = findLastNumber(p.titleRu, 'ru');
          }
          if (this.isMobile && p.titleRu !== undefined && p.titleEn !== undefined) {
            p.titleRu = this.setShortTitle(p.titleRu);
            p.titleEn = this.setShortTitle(p.titleEn);
          }
        })
        this.routeDto.destinationsText = [{text: ['Маршрут, ' + countRu, 'Route,' + countEn]}];
        this.routeDto.button = false;
        const continent = findFirstContinent(this.routeDto.points);
        if (continent !== undefined) {
          this.typeContent = continent.id?.toString();
          this.runningText = [{text: [continent.runningLineRu ?? '', continent.runningLineEn ?? '']}];
        }
        this.routeService.setMapId(this.routeDto.map ?? '658305');
        if (this.routeDto.url === 'antarctic-ultimate-expedition') {
          if (x !== 'location' || z !== 'antarctica') {
            this.handleUnauthorizedAccess();
          }
        } else {
          if (this.routeDto.displayPage === false) {
            this.handleUnauthorizedAccess();
          }
          if (this.routeDto.url === '') {
            this.handleUnauthorizedAccess();
          }
        }
        this.footerService.setFooterColor(this.routeDto.footerColor ?? 'rgba(57, 122, 158, 1)');
        this.footerService.setFooterImage(this.routeDto.footerImage ?? '');
        this.footerService.setFooterStyle(this.routeDto.cssStyleFooterImage ?? '');
        this.loading = false;
        this.loadSliderData();
        this.loadPointsData();
        this.loadHotelsData();
      });
  }

  private resetData() {
    this.routeDto = new LocationDto();
    this.sliderCards = [];
    this.points = [];
    this.antPoints = [];
    this.lastPoint = null;
    this.hotelCards = [];
    this.typeContent = undefined;
    this.runningText = [];
  }

  private handleUnauthorizedAccess() {
    if (this.tokenStorageService.getToken() !== undefined) {
      this.adminDisplay = true;
      this.uncorrectedUrl = true;
      this.displayPageFalse = true;
    } else {
      this.navigationService.backOrHome();
    }
  }

  private loadSliderData() {
    let loc;
    if (this.routeDto.url === 'antarctic-ultimate-expedition') {
      loc = findFirstContinent(this.routeDto.points);
    } else {
      loc = findFirstCountry(this.routeDto.points);
    }
    this.sliderCards = (loc?.carousels ?? []).map(v => new Card({
      id: v.id,
      title: [],
      text: [],
      img: environment.s3Prefix + v.image,
      style: v.cssStyle ?? '',
      flex: '',
      cssStyle: v.cssStyle ?? '',
      cloud: {
        title: [v.cloudTitleRu ?? '', v.cloudTitleEn ?? ''],
        text: [{text: [v.cloudDescriptionRu ?? '', v.cloudDescriptionEn ?? '']}],
        link: findTextByCss(v.cssStyle, 'link'),
        icon1: findIconByCss(v.cssStyle, 'icon', 1),
        icon2: findIconByCss(v.cssStyle, 'icon', 2),
        icon3: findIconByCss(v.cssStyle, 'icon', 3),
        textEn1: findTextByCss(v.cssStyle, 'textEn', 1),
        textEn2: findTextByCss(v.cssStyle, 'textEn', 2),
        textEn3: findTextByCss(v.cssStyle, 'textEn', 3),
        textRu1: findTextByCss(v.cssStyle, 'textRu', 1),
        textRu2: findTextByCss(v.cssStyle, 'textRu', 2),
        textRu3: findTextByCss(v.cssStyle, 'textRu', 3),
        paddingTop: 0,
        top: getCssNumber(v.cssStyle, 'top') ?? 50,
        left: getCssNumber(v.cssStyle, 'left') ?? 50,
      }
    }));
    this.loadingSlider = false;
    this.checkLoading();
  }

  private loadPointsData() {
    this.points = (this.routeDto.points ?? []).map(point => ({
      ...point,
      cards: (point.events ?? []).map(v => new Card({
        id: v.id,
        title: [v.titleRu ?? '', v.titleEn ?? ''],
        text: [v.descriptionRu ?? '', v.descriptionEn ?? ''],
        img: environment.s3Prefix + v.image,
        style: v.cssStyle ?? '',
        flex: '',
        tag: v.tag,
        tagRu: v.tagRu,
      }))
    }));
    this.antPoints = [...this.points];
    this.antPoints.splice(this.antPoints.length - 1, 1);
    this.antPoints.splice(this.points.length - 1, 1);
    this.lastPoint = this.points[this.points.length - 1];
  }

  private loadHotelsData() {
    const firstPoint = this.routeDto.points?.[0];
    const firstCity = firstPoint?.cities?.[0];
    this.hotelPaginationParams.countryId = firstCity?.country?.id?.toString() ?? '';

    this.hotelService.getHotelList(this.hotelPaginationParams)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.hotelCards = (data.content ?? []).map(v => {
          const path = v.image ? (environment.s3Prefix + v.image) : '/app/assets/images/hotel.png';
          let link: string | null = null;
          const continentUrl = v.city?.country?.continent?.url;
          const countryUrl = v.city?.country?.url;
          const cityUrl = v.city?.url;
          const hotelUrl = v.url;
          if (continentUrl && countryUrl && cityUrl && hotelUrl) {
            link = `${continentUrl}/${countryUrl}/${cityUrl}/${hotelUrl}`;
          }
          let descrRu = '';
          let descrEn = '';
          if (v.descriptionRu !== undefined) {
            descrRu = getFirstSentence(v.descriptionRu);
          }
          if (v.descriptionEn !== undefined) {
            descrEn = getFirstSentence(v.descriptionEn);
          }
          return new Card(
            {
              title: ['', ''],
              text: [v.titleRu ?? '', v.titleEn ?? ''],
              img: path,
              style: v.backgroundStyle?.toString() ?? '',
              button: false,
              link: link,
              rating: v.rating ?? 0,
              anotherButton: true,
              anotherHotelButton: true,
              anotherButtonText: [{text: [descrRu, descrEn]}],
            },
          );
        });
        this.loading = false;
      });
  }

  setHeight(height: number) {
    this.hotelHeight = height;
  }

  getHeight(type: 'one' | 'double' | 'margin') {
    const viewportHeight = window.innerHeight;
    switch (type) {
      case 'one':
        if (this.routeDto.url === 'antarctic-ultimate-expedition' || this.hotelCards.length === 0) {
          return {
            height: 'calc(100vh + 60px)'
          };
        }
        return {
          height: this.hotelHeight + 'px',
          '--sticky-top': `calc(100vh - ${this.hotelHeight}px)`
        };
      case "double":
        if (this.routeDto.url === 'antarctic-ultimate-expedition' || this.hotelCards.length === 0) {
          return {
            height: 'calc(200vh)'
          };
        }
        const wrapperHeight = this.hotelHeight + viewportHeight;
        return {height: wrapperHeight + 'px'};
      case "margin":
        return {'margin-top': `-${viewportHeight}px`};
    }
  }

  goToDestination(continent: Continent) {
    const url = '/destinations/' + continent.url?.toLowerCase().replaceAll(" ", "-");
    this.router.navigate([url], {relativeTo: this.route}).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }


  loadCircle(event: boolean) {
    this.loadingCircle = event;
    this.checkLoading();
  }

  setShortTitle(str: string): string {
    const colonIndex = str.indexOf(':');
    if (colonIndex === -1) {
      return str;
    }
    return str.substring(0, colonIndex).trim();
  }

  checkLoading() {
    if (this.loading || this.loadingCircle) {
      this.loadingService.setLoadingValue(true);
    }
    if (!this.loading && !this.loadingCircle) {
      this.loadingService.setLoadingValue(false);
    }
  }

  protected readonly CardsArray = CardsArray;
}
